/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable @typescript-eslint/indent */
import {
 Button, ModalBody, ModalFooter, ModalHeader, Text,
} from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import { Alert } from '@acp/core-ui';
import { ResolveIssueFormValues } from './form-schema';
import { PropertyAddressCard } from '../../../property/components/property-address-card';

function ResolveIssueConfirmation({
    propertyId,
    onBack,
    onSubmit,
    isLoading,
    error,
}: {
    propertyId: number;
    onSubmit: (vals: ResolveIssueFormValues) => void;
    onBack: () => void;
    isLoading: boolean;
    error: Error | null;
}) {
    const form = useFormContext<ResolveIssueFormValues>();
    const notes = form.watch('resolveReason');

    return (
        <>
            <ModalHeader>Confirm resolve access issue</ModalHeader>
            <ModalBody>
                <PropertyAddressCard w="full" mb={5} propertyId={propertyId} />

                <Text fontWeight="bold" fontSize="lg" mb={2}>
                    Resolve with reason
                </Text>
                <Text fontSize="md" mb={5}>
                    {notes}
                </Text>

                <Text fontWeight="bold" fontSize="lg" mb={2}>
                    What happens next?
                </Text>

                <Text>This issue will be marked as resolved</Text>

                {error !== null && (
                    <Alert status="error" mt={5} title="An error occurred while submitting your request. Please try again.">
                        {error.message}
                    </Alert>
                )}
            </ModalBody>

            <ModalFooter justifyContent="space-between">
                <Button colorScheme="muted" variant="ghost" onClick={onBack}>
                    Back
                </Button>
                <Button
                    colorScheme="secondary"
                    onClick={form.handleSubmit(onSubmit)}
                    isLoading={isLoading}
                >
                    Request resolve
                </Button>
            </ModalFooter>
        </>
    );
}

export { ResolveIssueConfirmation };
